import { render } from "./index.vue?vue&type=template&id=524fdc14&scoped=true&bindings={}"
import script from "./recommendations.js?vue&type=script&lang=js"
export * from "./recommendations.js?vue&type=script&lang=js"

import "./recommendations.scss?vue&type=style&index=0&id=524fdc14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-524fdc14"

export default script